// 关联回执类型
export enum EConnectReceiptType {
    /// <summary>
    /// 未关联
    /// </summary>
    None = 0,
    /// <summary>
    /// 主流程
    /// </summary>
    Master = 1,
    /// <summary>
    /// 子流程
    /// </summary>
    Slave = 2,
}